<template>
  <span :class="sider">{{ sider }}</span>
</template>

<script lang="ts">
import { PropType } from 'vue';
import { Component, Vue } from 'vue-property-decorator';

type Side = 'BORROW' | 'LOAN';

@Component({
  props: {
    side: String as PropType<Side>,
  },
})
export default class FormatSide extends Vue {
  protected readonly side!: Side;

  protected get sider(): string {
    switch (this.side) {
      case 'BORROW':
        return 'Borrower';
      case 'LOAN':
        return 'Lender';
      default:
        throw new Error(`Unknown side: ${this.side}`);
    }
  }
}
</script>

<style lang="scss">
.Lender {
  color: rgb(102, 186, 255);
}

.Borrower {
  color: rgb(76, 175, 80);
}
</style>
